import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../navbar.component/navbar.component';
import { BadgeComponent } from '../ui/badge.component/badge.component';
import { FooterComponent } from '../footer.component/footer.component';
import { PostsService } from 'src/app/service/posts.service';
import { Post } from 'src/app/dto';
import { start } from 'repl';
import { startWith } from 'rxjs';



@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    BadgeComponent
  ],
  templateUrl: './blog.component.html'
})
export class BlogComponent implements OnInit {
  posts: Post[] = [];
  isLoading = true;

  constructor(private postsService: PostsService) { }

  ngOnInit(): void {
    this.postsService.getPosts().pipe(startWith([]))
    .subscribe({
      next: posts => {
        this.posts = posts;
        this.isLoading = false;
      },
      error: () => {
        this.posts = [];
        this.isLoading = false;
      }
    });
  }
}
